export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ko": {
        "SEAR_TAB_ACT_CAHNNEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["최근활동"])}
      },
      "en": {
        "SEAR_TAB_ACT_CAHNNEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recent Activity"])}
      }
    }
  })
}
